import { css } from '@emotion/react';
// Constants
import { Color } from "../../constants/Colors";

export const useStyles = () => ({
    snackbarWrapper: css({
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        width: '100%',
        height: 65,
        zIndex: 13000,
        // boxShadow: "29px 29px 29px 20px rgba(0, 0, 0, 0.15)"
    }),
    snackbarContainer: css({
        '@media (min-width: 600px)': {
            paddingTop: 4,
            paddingLeft: '10%',
            paddingRight: '10%',
        },
        '@media (min-width: 1024px)': {
            paddingTop: 4,
            paddingLeft: '15%',
            paddingRight: '15%',
        },
    }),
    snackbarIconContainer: css({
        '& svg': {
            width: 30,
            height: 30,
            color: Color.neutral[0],
            marginTop: 6,
        },
    }),
    meter: css({
        height: 8,
        background: Color.gradient[100],
        overflow: 'hidden',
        animation: '$progressKeyframe linear',
        webkitAnimation: '$progressKeyframe linear',
    }),
});
